import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import App from './App';
import store from './store/Store';
import './index.css';
import './App.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_APP_CLIENT_ID}>
    {/* <StrictMode> */}
    <Provider store={store}>
      <App />
    </Provider>
    {/* </StrictMode> */}
  </GoogleOAuthProvider>
);
